import React from 'react';
import PropTypes from 'prop-types'
import {i18n} from 'react-i18n';
import AppStore from '../../stores/AppStore';
import AppActions from '../../actions/AppActions';
import TemplateData from '../../utility/getTemplateData';
import GlobalBanner from '../../components/globalBanner';
import SubHeader from '../../components/subHeader';
import Amount from '../../components/amount';
import CancelAndReturn from '../../components/cancelAndReturn';

const STYLES = {
	donateBtn: {
		maxWidth: '360px',
		margin: '20px auto 0px'
	},
	centralFormWrapper: {
		maxWidth: '500px',
		width: '100%',
		margin: '0 auto',
		padding: '0 18px',
	},
	donationSeparator: {
		marginBottom: '25px'
	},
	formTopLabelBold: {
		fontWeight: 'bold',
		marginTop: 31,
		fontSize: 15
	},
	formLabelBold: {
		fontWeight: 'bold',
		fontSize: 15
	},
	formLabelLeft: {
		width: '70%',
		fontSize: 15,
		textAlign: 'left'
	},
	formLabelRight: {
		width: '30%',
		fontSize: 15,
		textAlign: 'right'
	},
	formLabelLeftConv: {
		width: '70%',
		fontSize: 12,
		textAlign: 'left',
	},
	formLabelRightConv: {
		width: '30%',
		fontSize: 12,
		textAlign: 'right',
	},
	formLabelCenter: {
		width: '100%',
		marginTop: '10px',
		textAlign: 'center'
	},
	conversionBlock: {
		maxWidth: '500px',
		width: '100%',
		margin: '20px auto 10px',
		padding: '23px 0 20px 0',
		backgroundColor: '#F1F8FC',
		borderRadius: '5px'
	},
	formLabelRateLeft: {
		width: '70%',
		fontSize: 12,
		textAlign: 'left'
	},
	formLabelRateRight: {
		width: '30%',
		fontSize: 12,
		textAlign: 'right'
	},
	conversionRate: {
		maxWidth: '500px',
		width: '100%',
		padding: '0 18px',
		margin: '12px auto 40px'
	},
	policyMsg: {
		fontSize: '0.85em',
		textAlign: 'center',
		color: '#848B8E'
	}
};

const CrossBorder = React.createClass({
	mixins: [i18n('guest/crossBorder')],

	contextTypes: {
		router: PropTypes.object.isRequired
	},

	getInitialState() {
		let fundingOptions = AppStore.getFundingOptions();
		let [fundingSources] = fundingOptions.sources;
		let paymentNetwork = fundingSources.payment_card.network.toLowerCase();
		paymentNetwork = paymentNetwork.charAt(0).toUpperCase() + paymentNetwork.slice(1);
		let paymentDigits = fundingSources.payment_card.last_4;
		let exchangeRate = parseFloat(
			fundingOptions.currency_conversion.exchange_rate
		).toFixed(2);
		let fundsIn = fundingOptions.currency_conversion.funds_in;
		let fundsOut = fundingOptions.currency_conversion.funds_out;

		return {
			exchangeRate,
			subHeaderLabel: TemplateData.donationName,
			donationId: TemplateData.donationId,
			orgName: TemplateData.charityName,
			amountDecimalPoint: TemplateData.donationDecimalPoint || '.',
			paymentCard: `${paymentNetwork} x-${paymentDigits}`,
			decimalPoint: TemplateData.donationDecimalPoint || '.',
			inAmount: fundsIn.value,
			inCurrency: fundsIn.currency,
			inSymbol: fundsIn.symbol,
			outAmount: fundsOut.value,
			outCurrency: fundsOut.currency,
			outSymbol: fundsOut.symbol
		};
	},

	getLocalizedAmount(amount) {
		amount = (parseFloat(amount)).toFixed(2);
		return `${amount}`.replace(/[.|,]/i, this.state.amountDecimalPoint);
	},

	handleDonateClick() {
		$('.spinneroverlay').show();

		$.post('/donate/guest/fullfilment', {
			note: AppStore.getDonationNote(),
			fundingOptionId: AppStore.getFundingOptions().id,
			email: AppStore.getEmail(),
			billingAddress: AppStore.getBillingAddress()
		}, (result) => {
			if (result.status === 'redirect') {
				window.location.href = result.url;
			} else if (result.data && result.data.confirmationData) {
				let confirmationData = result.data.confirmationData || {};

				AppActions.updateConfirmation({confirmation: confirmationData});

				if (confirmationData.isOfacPending) {
					this.context.router.push('/donate/guest/pending');
				} else {
					this.context.router.push('/donate/guest/confirmation');
				}
			} else {
				window.location.href = '/donate/error/payment';
			}
		}).fail(() => {
			window.location.href = '/donate/error/payment';
		}).always(() => {
			$('.spinneroverlay').hide();
		});
	},

	render() {
		const inAmount = this.getLocalizedAmount(this.state.inAmount);
		const outAmount = this.getLocalizedAmount(this.state.outAmount);
		const fundsIn = `${this.state.inSymbol}${inAmount} ${this.state.inCurrency}`;
		const fundsOut = `${this.state.outSymbol}${outAmount} ${this.state.outCurrency}`;
		const exchangeRate = `${this.getLocalizedAmount('1.00')} ${this.state.inCurrency} = ${this.getLocalizedAmount(this.state.exchangeRate)} ${this.state.outCurrency}`;

		return (<div className="donate_wrapper">
			<div id="crossBorderContainer" className="container">
				<GlobalBanner logourl={this.state.logourl}/>
				<SubHeader
					label={this.state.subHeaderLabel}
					donationId={this.state.donationId}
					orgName={this.state.orgName}
				/>
				{ /* <Amount
					amount={outAmount}
					symbol={this.state.outSymbol}
					decimalPoint={this.state.decimalPoint}
					code={this.state.outCurrency}/> */ }

				<div style={STYLES.centralFormWrapper}>
					<label style={STYLES.formTopLabelBold}>
						{this.i18n('label.donatingFrom')}
					</label>
					<div
						className="donate_linner_div center-block"
						style={STYLES.donationSeparator}/>

					<label style={STYLES.formLabelLeft}>
						{this.state.paymentCard}
					</label>
					<label style={STYLES.formLabelRight}>
						{fundsIn}
					</label>
				</div>

				<div style={STYLES.conversionBlock}>
					<div style={STYLES.centralFormWrapper}>
						<label style={STYLES.formLabelLeft}>
							{this.i18n('label.youllDonate')}
						</label>
						<label style={STYLES.formLabelRight}>
							{fundsIn}
						</label>

						<label style={STYLES.formLabelLeftConv}>
							{this.i18n('label.convertsTo')}
						</label>
						<label style={STYLES.formLabelRightConv}>
							{fundsOut}
						</label>

						{ /*<label style={STYLES.formLabelCenter}>
							{this.i18n('label.conversion')} {exchangeRate}
						</label> */ }
					</div>
				</div>
				<div style={STYLES.conversionRate}>
					<label style={STYLES.formLabelRateLeft}>
						{this.i18n('label.conversion')} {exchangeRate}
					</label>
					<label style={STYLES.formLabelRateRight}>
						{fundsOut}
					</label>
				</div>

				<div
					style={STYLES.policyMsg}
					dangerouslySetInnerHTML={{__html: this.i18n('label.policies')}}/>

				<div style={STYLES.donateBtn}>
					<button
						type="button"
						style={{ marginBottom: '0px' }}
						className="vx_btn vx_btn-block"
						onClick={this.handleDonateClick}>
						{this.i18n('label.donatenow')}
					</button>
				</div>
				<CancelAndReturn />
			</div>
		</div>);
	}
});

export default CrossBorder;



// WEBPACK FOOTER //
// ./pages/guest/crossBorder.js